import { render, staticRenderFns } from "./dragVerifyImgChip.vue?vue&type=template&id=33b441e5&scoped=true"
import script from "./dragVerifyImgChip.vue?vue&type=script&lang=js"
export * from "./dragVerifyImgChip.vue?vue&type=script&lang=js"
import style0 from "./dragVerifyImgChip.vue?vue&type=style&index=0&id=33b441e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b441e5",
  null
  
)

export default component.exports